const state = {
    petInfo: {},
    petBreed: {},
  }
  
  const mutations = {
    SET_PETINFO: (state, petInfo) => {
      state.petInfo = petInfo
      sessionStorage.setItem('addPetInfo', JSON.stringify(petInfo))
    },
    SET_PRTBREED: (state, petBreed) => {
      state.petBreed = petBreed
      sessionStorage.setItem('petBreed', JSON.stringify(petBreed))
    },
  }
  
  const actions = {
   
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  